import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormInput, RadioButton, ProjectListHeader, ActionWithPlus } from '../../../components'
import { back, push } from '../../../actions/nav-actions'
import { fetchIndicators, putIndicators } from '../../../api';
import { notify, getDictionary } from '../../../utils'

var radio_props = [
  { label: 'Yes', value: 0 },
  { label: 'No', value: 1 }
];

class EvaluateContext extends Component {
  state = {
    project: {},
    is_loading: false,
    error: undefined,
    data: {},
    goal_indicators: []
  }
  constructor(props) {
    super(props);
    this.request = this.request.bind(this);
    this.getParams = this.getParams.bind(this);
    this.client = getDictionary(props.dictionary);
    this.getText = this.getText.bind(this);
  }
  getText(tag, category = 'indicators') {
    return this.client.get(category, tag);
  }
  getParams() {
    return this.props.match.params || {};
  }
  componentDidMount() {
    const params = this.getParams();
    this.setState({ is_loading: true, error: undefined }, () => {
      fetchIndicators(this.props.user.token,
        params.organization,
        params.code
      )
        .then((data) => {
          let goal_indicators = data.options.goals
          .reduce((acc, goal) => {
            return [...acc, goal, ...goal.subgoals];
          }, []).map((goal) => {
            let goal_indicator = {
              indicators: [{
                baselines: [],
                measure: '',
              }],
              goal: goal._id,
              goal_informations: goal
            };
            let gi = data.options.indicators.filter(i => i.goal === goal._id)[0];
            if (gi) {
              goal_indicator.indicators = gi.indicators;
              goal_indicator._id = gi._id;
            }
            return goal_indicator;
          });

          this.setState({ is_loading: false, data, goal_indicators });
        })
        .catch(err => this.setState({ is_loading: false, error: err }))
    });
  }
  request() {
    const params = this.getParams();
    putIndicators(
      this.props.user.token,
      params.organization,
      params.code,
      {
        ...this.state.data,
        goal_indicators: this.state.goal_indicators
      }
    )
      .then((data) => notify("Update informations", "Successfully updated!"))
      .catch((err) => notify('Error', err.message, 'error'))
  }
  render() {
    if (this.state.error) return <span>{this.state.error.message}</span>
    if (!this.state.data.indicators || this.state.is_loading) return <span>Loading data...</span>
    let { indicators, questions } = this.state.data;
    let { goal_indicators } = this.state;
    return (
      <React.Fragment>
        <ProjectListHeader title="GOALS AND INDICATORS" />
        <div>
          {goal_indicators.map((gi, index) => {
            return (
              <div key={index}>
                <ProjectListHeader title={gi.goal_informations.name} style={{ marginHorizontal: 0 }} />
                {gi.indicators.length === 0 &&
                  <p>No indicators</p>
                }
                {gi.indicators.map((indicator, indicator_index) => {
                  return (
                    <div key={indicator_index}>
                      <p>Indicator {indicator_index + 1}</p>
                      <FormInput
                        value={indicator.measure}
                        onChange={(text) => {
                          goal_indicators[index].indicators[indicator_index].measure = text;
                          this.setState({ goal_indicators });
                        }}
                        style={{ marginTop: 8 }}
                        placeholder="Please state what indicator measures this particular goal/subgoal" />
                      <p>Baselines</p>
                      {
                        (indicator.baselines || []).length === 0 &&
                        <p>No indicators</p>
                      }
                      {
                        (indicator.baselines || []).map((baseline, baseline_index) => {
                          return (
                            <div key={baseline_index}>
                              <FormInput
                                value={baseline}
                                onChange={(text) => {
                                  goal_indicators[index].indicators[indicator_index].baselines[baseline_index] = text;
                                  this.setState({ goal_indicators });
                                }}
                                style={{ marginTop: 8 }}
                                placeholder="Please state the baseline for this indicator" />
                            </div>
                          );
                        })
                      }

                      <div>
                        <p>Updated baseline:</p>
                        <FormInput
                          value={gi.indicators[indicator_index].new_baseline}
                          onChange={(text) => {
                            goal_indicators[index].indicators[indicator_index].new_baseline = text;
                            this.setState({ goal_indicators });
                          }}
                          style={{ marginTop: 8 }}
                          placeholder="Please state the updated baseline for this indicator" />
                        <ActionWithPlus
                          style={{ marginTop: 8 }}
                          onClick={() => {

                            if (!goal_indicators[index].indicators[indicator_index].new_baseline) return;
                            if (goal_indicators[index].indicators[indicator_index].new_baseline.trim().length === 0) return;

                            goal_indicators[index].indicators[indicator_index].baselines =
                              goal_indicators[index].indicators[indicator_index].baselines.concat([goal_indicators[index].indicators[indicator_index].new_baseline]);
                            goal_indicators[index].indicators[indicator_index].new_baseline = undefined;
                            this.setState({ goal_indicators });
                          }}
                          label="Save this indicator and add a new baseline" />
                      </div>
                    </div>
                  )
                })}
                <p>Create new indicator</p>
                <FormInput
                  value={gi.new_indicator}
                  onChange={(text) => {
                    goal_indicators[index].new_indicator = text;
                    this.setState({ goal_indicators });
                  }}
                  style={{ marginTop: 8 }}
                  placeholder="Please state what indicator measures this particular goal/subgoal" />
                <ActionWithPlus
                  style={{ marginTop: 8, marginBottom: 32 }}
                  onClick={() => {
                    if (!goal_indicators[index].new_indicator) return;
                    if (goal_indicators[index].new_indicator.trim().length === 0) return;

                    goal_indicators[index].indicators =
                      goal_indicators[index].indicators.concat([{
                        baselines: [],
                        measure: goal_indicators[index].new_indicator.trim()
                      }]);
                    goal_indicators[index].new_indicator = undefined;
                    this.setState({ goal_indicators });
                  }}
                  label={"Save as new indicator for " + gi.goal_informations.name} />
              </div>
            )
          })}
        </div>

        <ProjectListHeader title="QUESTIONS TO CONSIDER" />
        <div>
          <p>{this.getText('questions_description')}</p>
          <div>
            <p>{this.getText('connected_goals_and_objectives_question')}</p>
            <RadioButton
              data={radio_props}
              initial={indicators.questions.connected_goals_and_objectives.value ? 0 : 1}
              onChange={(value) => {
                let { indicators } = this.state.data;
                indicators.questions.connected_goals_and_objectives.value = (value === 0);
                this.setState({
                  data: { ...this.state.data, indicators }
                });
              }}
            />
            <FormInput
              value={indicators.questions.connected_goals_and_objectives.text}
              onChange={(text) => {
                let { indicators } = this.state.data;
                indicators.questions.connected_goals_and_objectives.text = text;
                this.setState({
                  data: { ...this.state.data, indicators }
                });
              }}
              placeholder="" />
          </div>
        </div>

        <div>
          <p>{this.getText('meaningful_question')}</p>
          <RadioButton
            data={radio_props}
            formHorizontal={true}
            style={{ marginTop: 16 }}
            initial={indicators.questions.meaningful.value ? 0 : 1}
            onChange={(value) => {
              let { indicators } = this.state.data;
              indicators.questions.meaningful.value = (value === 0);
              this.setState({
                data: { ...this.state.data, indicators }
              });
            }}
          />
          <FormInput
            value={indicators.questions.meaningful.text}
            onChange={(text) => {
              let { indicators } = this.state.data;
              indicators.questions.meaningful.text = text;
              this.setState({
                data: { ...this.state.data, indicators }
              });
            }}

            placeholder="" />
        </div>

        <div>
          <p>{this.getText('measurable_question')}</p>
          <RadioButton
            data={radio_props}
            formHorizontal={true}
            style={{ marginTop: 16 }}
            initial={indicators.questions.measurable.value ? 0 : 1}
            onChange={(value) => {
              let { indicators } = this.state.data;
              indicators.questions.measurable.value = (value === 0);
              this.setState({
                data: { ...this.state.data, indicators }
              });
            }}
          />
          <FormInput
            value={indicators.questions.measurable.text}
            onChange={(text) => {
              let { indicators } = this.state.data;
              indicators.questions.measurable.text = text;
              this.setState({
                data: { ...this.state.data, indicators }
              });
            }}

            placeholder="" />
        </div>

        <div>
          <p>{this.getText('culturally_and_locally_question')}</p>
          <RadioButton
            data={radio_props}
            formHorizontal={true}
            style={{ marginTop: 16 }}
            initial={indicators.questions.culturally_and_locally.value ? 0 : 1}
            onChange={(value) => {
              let { indicators } = this.state.data;
              indicators.questions.culturally_and_locally.value = (value === 0);
              this.setState({
                data: { ...this.state.data, indicators }
              });
            }}
          />
          <FormInput
            value={indicators.questions.culturally_and_locally.text}
            onChange={(text) => {
              let { indicators } = this.state.data;
              indicators.questions.culturally_and_locally.text = text;
              this.setState({
                data: { ...this.state.data, indicators }
              });
            }}

            placeholder="" />
        </div>

        <div>
          <p>{this.getText('sensitive_question')}</p>
          <RadioButton
            data={radio_props}
            formHorizontal={true}
            style={{ marginTop: 16 }}
            initial={indicators.questions.sensitive.value ? 0 : 1}
            onChange={(value) => {
              let { indicators } = this.state.data;
              indicators.questions.sensitive.value = (value === 0);
              this.setState({
                data: { ...this.state.data, indicators }
              });
            }}
          />
          <FormInput
            value={indicators.questions.sensitive.text}
            onChange={(text) => {
              let { indicators } = this.state.data;
              indicators.questions.sensitive.text = text;
              this.setState({
                data: { ...this.state.data, indicators }
              });
            }}

            placeholder="" />
        </div>

        <div>
          <p>{this.getText('time_and_geographically_question')}</p>
          <RadioButton
            data={radio_props}
            formHorizontal={true}
            style={{ marginTop: 16 }}
            initial={indicators.questions.time_and_geographically.value ? 0 : 1}
            onChange={(value) => {
              let { indicators } = this.state.data;
              indicators.questions.time_and_geographically.value = (value === 0);
              this.setState({
                data: { ...this.state.data, indicators }
              });
            }}
          />
          <FormInput
            value={indicators.questions.time_and_geographically.text}
            onChange={(text) => {
              let { indicators } = this.state.data;
              indicators.questions.time_and_geographically.text = text;
              this.setState({
                data: { ...this.state.data, indicators }
              });
            }}

            placeholder="" />
        </div>

        <div>
          <p>{this.getText('comprehensive_question')}</p>
          <RadioButton
            data={radio_props}
            formHorizontal={true}
            style={{ marginTop: 16 }}
            initial={indicators.questions.comprehensive.value ? 0 : 1}
            onChange={(value) => {
              let { indicators } = this.state.data;
              indicators.questions.comprehensive.value = (value === 0);
              this.setState({
                data: { ...this.state.data, indicators }
              });
            }}
          />
          <FormInput
            value={indicators.questions.comprehensive.text}
            onChange={(text) => {
              let { indicators } = this.state.data;
              indicators.questions.comprehensive.text = text;
              this.setState({
                data: { ...this.state.data, indicators }
              });
            }}

            placeholder="" />
        </div>

        <div>
          <p>{this.getText('coast_and_time_question')}</p>
          <RadioButton
            data={radio_props}
            formHorizontal={true}
            style={{ marginTop: 16 }}
            initial={indicators.questions.coast_and_time.value ? 0 : 1}
            onChange={(value) => {
              let { indicators } = this.state.data;
              indicators.questions.coast_and_time.value = (value === 0);
              this.setState({
                data: { ...this.state.data, indicators }
              });
            }}
          />
          <FormInput
            value={indicators.questions.coast_and_time.text}
            onChange={(text) => {
              let { indicators } = this.state.data;
              indicators.questions.coast_and_time.text = text;
              this.setState({
                data: { ...this.state.data, indicators }
              });
            }}

            placeholder="" />
        </div>

        <div>
          {questions.map((question, index) => {
            return (
              <div key={index}>
                <p>Question:</p>
                <FormInput
                  value={question.description}
                  onChange={(value) => {
                    let { questions } = this.state.data;
                    questions[index].description = value;
                    this.setState({
                      data: {
                        ...this.state.data,
                        questions
                      }
                    });
                  }}
                  placeholder="" />
                <p>Answer:</p>
                <FormInput
                  value={question.value}
                  onChange={(value) => {
                    let { questions } = this.state.data;
                    questions[index].value = value;
                    this.setState({
                      data: {
                        ...this.state.data,
                        questions
                      }
                    });
                  }}
                  placeholder="" />
              </div>
            )
          })}
        </div>

        <ActionWithPlus
          onClick={() => {
            this.props.push(`/projects/${this.props.match.params.organization}/${this.props.match.params.code}/questions/indicators`)
          }}
          style={{ marginTop: 24, marginBottom: 32 }}
          label="Add question" />

        <div classNAme="clearfix" />

        <button
          className="btn btn-info"
          onClick={this.request.bind(this)}
          style={{ marginTop: 24, marginBottom: 24 }}>
          SAVE
        </button>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({ ...state.localStorage, user: state.authReducer.user });

const mapDispatchToProps = dispatch => ({
  back() {
    dispatch(back())
  },
  push(routeName) {
    dispatch(push(routeName))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(EvaluateContext);


// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/IndicatorsFormularies.js